
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ProductShowcase from './components/ProductShowcase';
import NYDFSSection from './components/NYDFSSection';
import TrustSection from './components/TrustSection';
import UrgencySection from './components/UrgencySection';
import { useSEO, SITE_URL } from '../../hooks/useSEO';

const HomePage = () => {
  useSEO({
    title: 'Cybersecurity for Financial Firms Nationwide | Mortgage Moat',
    description: 'Mortgage Moat protects financial firms nationwide from cyber threats with 99.7% success rate. Get cybersecurity protection, phishing prevention, and team training in 24 hours.',
    keywords: 'cybersecurity financial firms, phishing protection, mortgage security, GLBA compliance, FFIEC cybersecurity',
    canonical: '/',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Mortgage Moat',
        url: SITE_URL,
        logo: 'https://static.readdy.ai/image/807f7a13fa3a4707437af02957aa93c9/1baf6cd348ab623aee3f3ee6959ea81e.png',
        description: 'Cybersecurity solutions for financial firms and mortgage companies nationwide.',
        telephone: '+1-844-662-8277',
        email: 'sales@mortgagemoat.com',
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+1-844-662-8277',
          contactType: 'customer service',
          email: 'sales@mortgagemoat.com',
          availableLanguage: 'English',
        },
        sameAs: [
          'https://www.facebook.com/mortgagemoat',
          'https://www.linkedin.com/company/mortgage-moat',
          'https://www.instagram.com/mortgagemoat',
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'Mortgage Moat',
        url: SITE_URL,
        potentialAction: {
          '@type': 'SearchAction',
          target: `${SITE_URL}/?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        '@id': `${SITE_URL}/`,
        url: `${SITE_URL}/`,
        name: 'Cybersecurity for Financial Firms Nationwide | Mortgage Moat',
        description: 'Mortgage Moat protects financial firms nationwide from cyber threats with 99.7% success rate.',
        isPartOf: { '@id': SITE_URL },
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE_URL}/` },
          ],
        },
      },
    ],
  });

  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <NYDFSSection />
      <ProductShowcase />
      <TrustSection />
      <UrgencySection />
      <Footer />
    </div>
  );
};

export default HomePage;
